import getSplashApiClient from 'lib/SplashApiClient/singleton';

/**
 * Wraps a SplashApiClient with the Workspace API actions
 */
export default class TouchpointsApiClient {
    /**
     * @param {SplashApiClient} apiClient
     */
    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    /**
     * Get events based on passed criteria
     * @param  {object} options
     * @param  {number} eventId
     *
     * @return {promise}
     */
    fetchTouchpoints(options, eventId) {
        return this.apiClient.get(`events/${eventId}/workspaces`, options);
    }

    /**
     * Get an individual touchpoint for a given event
     * @param  {number} eventId
     * @param  {string} touchpointType
     *
     * @return {promise}
     */
    getTouchpointByType(eventId, touchpointType) {
        return this.apiClient.get(`events/${eventId}/workspaces/${touchpointType}`);
    }

    /**
     * Update an individual touchpoint for a given event
     * @param  {object} options
     * @param  {number} eventId
     * @param  {string} touchpointType
     *
     * @return {promise}
     */
    patchTouchpoint(options, eventId, touchpointType) {
        return this.apiClient.patch(`events/${eventId}/workspaces/${touchpointType}`, options);
    }
}

export const getTouchpointsApiClient = () => new TouchpointsApiClient(getSplashApiClient());
